export const xShareUrl = (url) => `https://x.com/intent/post?url=${encodeURIComponent(url)}`;
export const facebookShareUrl = url => `http://www.facebook.com/sharer.php?u=${url}`;
export const emailShareUrl = (url, text) => `mailto:?subject=${text}&body=${url}`;
export const whatsappWebUrl = (url) => `https://web.whatsapp.com/send?text=${url}`;
export const whatsappMobileUrl =(url) => `https://wa.me/?text=${url}`;
export const linkedInShareUrl = (url) =>`https://www.linkedin.com/sharing/share-offsite/?url=${url}`

// export const makeWhatsappShareUrl = url => `whatsapp://send?text=${url}`;
// `https://t.me/share/url?url=${url}&text=${text}&to=${to}`;
// export const makeWhatsappShareUrl = url => `https://api.whatsapp.com/send?text=${url}`;
// twitter share `https://twitter.com/share?url=${url}&text=${text}`;
// export const makeXShareUrl = (url, text) => `https://x.com/intent/post?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;

